export enum UserType {
  Chef = 2,
  Manager = 5,
  Preparator = 6,
}
